import CoverImageBackground from './CoverImageBackground';

export default CoverImageBackground;
